const { _APP_CONFIG } = window;

export const REACT_APP_API = _APP_CONFIG.api.endpoint;
export const REACT_APP_CLIENT_WEBSITE = _APP_CONFIG.client.website;
export const GOOGLE_MAPS_GEOCODING_KEY = _APP_CONFIG.googleMaps.geocoding;
export const REACT_APP_LOGO = _APP_CONFIG.app.logo;
